var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomoutIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 49,
    viewBox: "0 0 46 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.0695,
    cy: 19.5139,
    r: 16.8647,
    stroke: "#FB7C51",
    strokeWidth: 3.68104
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3232 33.8047L43.6293 47.1125",
    stroke: "#FB7C51",
    strokeWidth: 3.68104,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5393 27.7158V11.3125H21.3229V27.7158H18.5393ZM11.7295 20.9059V18.1223H28.1328V20.9059H11.7295Z",
    fill: "#FB7C51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomoutIcon);
export default __webpack_public_path__ + "static/media/zoomoutIcon.2f679e23d23113843fdf00b1becc63d6.svg";
export { ForwardRef as ReactComponent };